import { StepNav, TextButton } from 'slab'
import type { AcaReportingConfigStatus } from 'utils/web_api.schemas'

import DownloadAndFileInstructions from './DownloadAndFileInstructions'

interface StatusConfirmationProps {
  planYear: number
  status: AcaReportingConfigStatus
  selfReportedAleStatus?: boolean
  onChangeStatus: () => void
}

export default function StatusConfirmation ({
  status,
  selfReportedAleStatus,
  onChangeStatus
}: StatusConfirmationProps) {
  const isOptedIn = status === 'opted_in'
  const isOptedOut = status === 'opted_out'
  const canChangeStatus = status === 'opted_in' || status === 'draft_ready' || status === 'opted_out'
  const formType = selfReportedAleStatus === true ? '1095-C' : '1095-B'

  return (
    <div className='space-y-6'>
      <div>
        <h1 className='text-2xl text-gray-800 mb-10'>
          {isOptedIn && "You've opted in to Thatch ACA filing! 🎉"}
          {isOptedOut && "You've opted out of Thatch ACA filing"}
        </h1>
        <h2 className='text-xl text-gray-800'>
          {isOptedIn && "Here's what will happen next:"}
          {isOptedOut && "Here's what you have to do next:"}
        </h2>
      </div>

      <div className='bg-white rounded-lg border border-gray-200 p-6'>
        {isOptedIn && (
          <div className='[&_.text-green-400]:text-thatch-600'>
            <StepNav>
              <StepNav.Step name='Today' active complete>
                <p className='text-xs mb-10'>
                  We've got your opt-in and we'll compile your employee data from throughout the year
                </p>
              </StepNav.Step>

              <StepNav.Step name='Before the end of February'>
                <ol className='text-xs text-gray-600'>
                  <li>1. We'll reach back out for any corrections that need to be made prior to filing</li>
                  <li>2. Afterwards, look out for an email from Thatch — we'll notify you when your {formType}s have been sent to employees and filed with the IRS</li>
                </ol>
              </StepNav.Step>
            </StepNav>
          </div>
        )}

        {isOptedOut && (
          <DownloadAndFileInstructions formType={formType} />
        )}
      </div>
      {canChangeStatus && (
        <div className='text-left'>
          <TextButton color='gray' size='small' onClick={onChangeStatus}>
            {isOptedIn && 'Changed your mind? Opt out here.'}
            {isOptedOut && 'Changed your mind? Opt in here.'}
          </TextButton>
        </div>
      )}
    </div>
  )
}
